// Shared UI/application constants

// Default LLM model to use when none is selected (aligns with backend dev default)
export const DEFAULT_LLM = 'gemini-3.1-flash-lite'

// Default weather models string (ordered)
export const DEFAULT_MODELS = 'ecmwf-aifs,ecmwf-ifs,ncep-gfs,dwd-icon'


